module.exports = __webpack_public_path__ + "assets_1699926722187/img/invite_banner.b8b1cdfa.gif";